<div [class]="uiService.theme()">
    <router-outlet></router-outlet>
</div>
